import { StatusPageResource } from "../../Stores/StatusPage";
import { useConfigStore } from "../../Stores/Config";
import "./StatusCard.scss";

interface StatusCardProps {
  statusPageName: string;
  statusPageUrl?: string;
  aggregateState: string;
  resources: StatusPageResource[];
}

type AggregateStateInfo = {
  label: string;
  color: string;
};

function getAggregateStateInfo(
  state: string,
  translate: (key: string) => string
): AggregateStateInfo {
  switch (state) {
    case "operational":
      return {
        label: translate("statusAllOperational") || "All services are online",
        color: "#22c55e",
      };
    case "degraded":
      return {
        label: translate("statusDegraded") || "Some services are degraded",
        color: "#f59e0b",
      };
    case "downtime":
      return {
        label: translate("statusOutage") || "Service outage detected",
        color: "#ef4444",
      };
    case "maintenance":
      return {
        label: translate("statusMaintenance") || "Scheduled maintenance",
        color: "#3b82f6",
      };
    default:
      return {
        label: translate("statusUnknown") || "Status unknown",
        color: "#6b7280",
      };
  }
}

function StatusCard({
  statusPageUrl,
  aggregateState,
}: StatusCardProps) {
  const configStore = useConfigStore();
  const translate = configStore.translateText;
  const aggregateInfo = getAggregateStateInfo(aggregateState, translate);
  const isHealthy = aggregateState === "operational";

  return (
    <div className={`status-card${isHealthy ? " status-card--healthy" : ""}`}>
      {isHealthy ? (
        <div className="status-card-healthy-row">
          <div
            className="status-card-indicator status-card-indicator--small"
            style={
              {
                backgroundColor: aggregateInfo.color,
                ["--indicator-color" as any]: aggregateInfo.color,
              } as React.CSSProperties
            }
            aria-hidden="true"
          />
          <span className="status-card-healthy-label">{aggregateInfo.label}</span>
          {statusPageUrl && (
            <a
              className="status-card-healthy-link"
              href={statusPageUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              {translate("statusViewPage") || "View status page"}
            </a>
          )}
        </div>
      ) : (
        <div className="status-card-overview">
          <div
            className="status-card-indicator"
            style={
              {
                backgroundColor: aggregateInfo.color,
                ["--indicator-color" as any]: aggregateInfo.color,
              } as React.CSSProperties
            }
            aria-hidden="true"
          >
            !
          </div>
          <div className="status-card-overview-label">{aggregateInfo.label}</div>
        </div>
      )}

      {!isHealthy && statusPageUrl && (
        <div className="status-card-footer">
          <a href={statusPageUrl} target="_blank" rel="noopener noreferrer">
            {translate("statusViewPage") || "View status page"}
          </a>
        </div>
      )}
    </div>
  );
}

export default StatusCard;
